__turbopack_context__.v({
  "className": "playfair_display_a8d8a9c0-module___BaRxG__className",
  "variable": "playfair_display_a8d8a9c0-module___BaRxG__variable",
});
